import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import { translate } from "react-i18next";
import Avatar from "@material-ui/core/Avatar";
import Typography from "@material-ui/core/Typography";
import NumberFormat from "react-number-format";

import { AppMenu } from "../AppMenu";
import { THEME } from "../_constants";
import "./ProfilePage.css";

const FORM_WIDTH = 360;

const styles = theme => ({
    root: {
        position: "fixed",
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        display: "flex",
        flexDirection: "column"
    },
    body: {
        flexGrow: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: THEME.COLOR.GRAY
    },
    form: {
        height: 704,
        width: FORM_WIDTH,
        display: "flex",
        flexDirection: "column",
        paddingLeft: 158,
        paddingRight: 158,
        opacity: 1
    },
    header: {
        marginTop: 60,
        marginBottom: 30,
        display: "flex",
        flexDirection: "row",
        alignItems: "center"
    },
    avatar: {
        width: 80,
        height: 80,
        backgroundColor: THEME.COLOR.GREEN,
        marginRight: 30
    },
    account: {
        display: "flex",
        flexDirection: "column"
    },
    bootstrapRoot: {
        "label + &": {
            marginTop: theme.spacing.unit * 3
        }
    },
    bootstrapInput: {
        borderRadius: 4,
        backgroundColor: theme.palette.common.white,
        border: "1px solid #ced4da",
        fontSize: 16,
        padding: "10px 12px",
        transition: theme.transitions.create(["border-color", "box-shadow"]),
        fontFamily: [
            "-apple-system",
            "BlinkMacSystemFont",
            '"Segoe UI"',
            "Roboto",
            '"Helvetica Neue"',
            "Arial",
            "sans-serif",
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"'
        ].join(","),
        "&:focus": {
            borderColor: "#80bdff",
            boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)"
        }
    },
    bootstrapFormLabel: {
        fontSize: 18
    }
});

class ProfilePage extends React.Component {
    constructor(props) {
        super(props);

        let user = props.user;
        this.state = {
            edited: false,
            fullname: user.fullname,
            username: user.username,
            phone: user.phone
        };

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange = key => event => {
        this.setState({
            edited: true,
            [key]: event.target.value
        });
    };

    render() {
        const { t, classes, location, user } = this.props;
        const state = this.state;
        const self = this;

        function renderHeader() {
            function formatNumber(value) {
                return (
                    <NumberFormat
                        value={value}
                        displayType={"text"}
                        thousandSeparator={"."}
                        decimalSeparator={","}
                        renderText={value => value}
                    />
                );
            }

            return (
                <div className={classes.header}>
                    <Avatar className={classes.avatar}>
                        <Typography
                            variant="title"
                            style={{
                                color: "white",
                                fontSize: 28
                            }}
                        >
                            {user.fullname.charAt(0).toUpperCase()}
                        </Typography>
                    </Avatar>
                    <div className={classes.account}>
                        <Typography
                            variant="title"
                            style={{
                                fontSize: 16
                            }}
                        >
                            {user.fullname}
                        </Typography>
                        <Typography
                            variant="subheading"
                            style={{
                                fontSize: 14,
                                marginTop: 5
                            }}
                        >
                            {formatNumber(user.balance)} đ
                        </Typography>
                    </div>
                </div>
            );
        }

        function renderInput(value, placeholder) {
            return (
                <TextField
                    style={{ width: FORM_WIDTH, marginBottom: 15 }}
                    value={state[value]}
                    placeholder={placeholder}
                    onChange={self.handleChange(value)}
                    InputProps={{
                        disableUnderline: true,
                        classes: {
                            root: classes.bootstrapRoot,
                            input: classes.bootstrapInput
                        }
                    }}
                    InputLabelProps={{
                        shrink: true,
                        className: classes.bootstrapFormLabel
                    }}
                />
            );
        }

        function renderAccountInfoInputs() {
            return (
                <div>
                    {renderInput("fullname", t("AccountName"))}
                    {renderInput("username", t("Email"))}
                    {renderInput("phone", t("PhoneNumber"))}
                </div>
            );
        }

        function renderChangePassInputs() {
            return (
                <div>
                    {renderInput("oldPass", t("Mật khẩu cũ"))}
                    {renderInput("newPass", t("Mật khẩu mới"))}
                    {renderInput("confirmPassword", t("ConfirmPassword"))}
                </div>
            );
        }

        function renderGroupInputs(tilte, content) {
            return (
                <div>
                    <Typography
                        variant="title"
                        style={{
                            fontSize: 15,
                            marginTop: 20,
                            marginBottom: 22
                        }}
                    >
                        {tilte}
                    </Typography>
                    {content}
                </div>
            );
        }

        return (
            <div className={classes.root}>
                <AppMenu location={location} />
                <div className={classes.body}>
                    <form
                        className={classes.form}
                        name="form"
                        noValidate
                        autoComplete="off"
                        onSubmit={this.handleSubmit}
                    >
                        {renderHeader()}
                        {renderGroupInputs(
                            "Thông tin tài khoản",
                            renderAccountInfoInputs()
                        )}
                        {renderGroupInputs(
                            "Đổi mật khẩu",
                            renderChangePassInputs()
                        )}

                        <Button
                            disabled={!state.edited}
                            style={{
                                backgroundColor: state.edited
                                    ? THEME.COLOR.BLUE
                                    : THEME.COLOR.GRAY,
                                color: "white",
                                marginTop: 22,
                                width: 150,
                                marginLeft: FORM_WIDTH - 150
                            }}
                            variant="raised"
                            // onClick={event => this.handleSubmit(event)}
                        >
                            {t("Update")}
                        </Button>
                    </form>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { authentication } = state;
    const { user } = authentication;
    return {
        user
    };
}

const styleRegister = withStyles(styles)(
    translate("translations")(ProfilePage)
);

const connectedProfilePage = connect(mapStateToProps)(styleRegister);
export { connectedProfilePage as ProfilePage };



// WEBPACK FOOTER //
// ./src/ProfilePage/ProfilePage.js